import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// Sends the wos_session HttpOnly cookie (set by /headless/auth/callback) with requests to our
// own API, which is on a different origin from the app. Requests to anyone else are left
// alone: the cookie is not theirs, and servers that answer with "Access-Control-Allow-Origin: *"
// (the exchange-rate service, the CORS proxy for news feeds) have their responses refused by
// the browser when the request was sent with credentials.
@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.api_root)) {
      return next.handle(req);
    }
    return next.handle(req.clone({ withCredentials: true }));
  }
}
